exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".textearea-container {\n  margin-top: 30px;\n  margin-left: 10px;\n  margin-right: 10px; }\n\n.checkbox-container {\n  margin-left: 10px;\n  margin-top: 30px; }\n\n.content-container {\n  margin-left: 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/feedback-modal/feedback-modal.component.scss
// module id = ../../../../../src/app/components/feedback-modal/feedback-modal.component.scss
// module chunks = main